import React from 'react';
import logo from '../../../images/logo-payu-white.svg';

const PayuLogo = () => {
  return (
        <div>
            <img src={logo} alt="Logo" className="payu-logo"/>
        </div>
  );
};

export default PayuLogo;
